<template>
  <div :id="cpntHashId" class="filtro-busca-telas">
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA OS DADOS DA PAGINA -->
    <div v-else>
      <!-- SETA O BOTÃO PARA ABRIR OS OUTROS FILTROS -->
      <RF-Button v-if="filtroBT !== null" class="filtro-bt" :class="filtrado === true ? 'piscando' : ''"
        :cpntId='filtroBT.id'
        :cpntStatus='filtroBT.status' 
        :cpntTexto='filtroBT.texto'
        :cpntTipo='filtroBT.tipo'
        :cpntIcone='filtroBT.icone'
        :cpntClass='filtroBT.class' 

        @onClickButton='filtroBT.onClick'
      ></RF-Button>

      <!-- SETA O CAMPO DE BUSCA -->
      <div v-if='chaveBusca !== null' :class="'busca filtro-' + chaveBusca">
        <div class="input-group">
          <!-- SETA O INPUT DE BUSCA -->
          <input :data-time='time' class="form-control" type="text" 
            :class="cpntField[chaveBusca].class" 
            :placeholder="cpntField[chaveBusca].placeholder" 
            @keyup.enter='filtroBuscaTelaAplicar' 
            v-model='cpntField[chaveBusca].value'
            ref='busca'>

          <!-- SETA O BOTÃO DE BUSCA -->
          <span class="input-group-addon" style="cursor: pointer;" @click='filtroBuscaTelaAplicar'><i class="fa fa-search"></i></span>
        </div>
      </div>
    </div>
    
    <!-- FAZ A QUEBRA DO FLOAT -->
    <span style="clear: both;"></span>

    <RF-Dialog v-if="filtroBT !== null && filtroBT.dialog === true" :class="filtroBT.tamanho === '95%' ? 'mobile' : ''"
    :cpntStatus='statusGeral'
    :cpntLargura='filtroBT.tamanho'
    :cpntTitulo='cpntTitulo'
    :cpntOnFecharDialog='filtroBT.onClick'>
    <!-- <template slot="titulo">
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      <span v-html="cpntTitulo"></span>
    </template> -->

    <template slot="conteudo">
      <RF-Filtro-Busca-Telas-Campos :cpntTime='time' :cpntField="cpntField" :cpntHashId="cpntHashId"></RF-Filtro-Busca-Telas-Campos>
    </template>

    <template slot="rodape" v-if="buttonsRod !== null">
      <div class="filtro-busca-telas-dialog-rodape">
        <template v-for='(button, index) in buttonsRod'>
          <RF-Button :key="index" v-if="index !== 'limpar' || filtrado === true"
            :data-time='time'

            :cpntStatus='button.status' 
            :cpntId='button.id' 
            :cpntTexto='button.texto' 
            :cpntClass='button.class'
            :cpntMostrar='button.mostrar'
            :cpntTabIndex='button.tabIndex'

            @onClickButton='button.onClick'
          ></RF-Button>
        </template>
      </div>
    </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
.filtro-busca-telas > div {
  width: calc(100% - 115px);
  float: right;
  text-align: right;
}
  .filtro-busca-telas > div > .filtro-bt {
    margin: -21px 10px 5px 0px;
    width: 50px;
    height: 34px;
  }
  .filtro-busca-telas > div > .filtro-bt,
  .filtro-busca-telas > div > div {
    display: inline-block;
  }
  .filtro-busca-telas > div > .busca {
    width: calc(100% - 60px);
    max-width: 300px;
  }
  .filtro-busca-telas-dialog-rodape {
    text-align: right;
  }
    .filtro-busca-telas-dialog-rodape > button {
      margin: 5px 0px 5px 5px;
    }
</style>

<style>
.filtro-busca-telas > div > .filtro-bt,
.filtro-busca-telas > div > .busca > div > input.form-control {
  border: 1px solid #2e6da4;
}
  .filtro-busca-telas > div > .filtro-bt > span > svg {
    color: #337ab7;
  }
.filtro-busca-telas > div > .busca > div > input.form-control ~ .input-group-addon {
  background: #337ab7;
  border: 1px solid #2e6da4;
  cursor: pointer;
}
  .filtro-busca-telas > div > .busca > div > input.form-control ~ .input-group-addon > svg {
    color: #fff;
  }

.filtro-busca-telas > .dialog.mobile > .dialog-conteudo,
.filtro-busca-telas > .dialog.mobile > .dialog-conteudo > table {
  max-width: 400px;
}
@media only screen and (max-width: 500px) {
  .filtro-busca-telas > .dialog.mobile > .dialog-conteudo > table {
    position: fixed;
    left: 1%;
  }
}
@keyframes icone-piscando {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 0; }
}
.filtro-busca-telas > div > .piscando > span > svg {
  -webkit-animation: icone-piscando 1s ease-in-out infinite alternate;
  -moz-animation: icone-piscando 1s ease-in-out infinite alternate;
  -ms-animation: icone-piscando 1s ease-in-out infinite alternate;
  -o-animation: icone-piscando 1s ease-in-out infinite alternate;
  animation: icone-piscando 1s ease-in-out infinite alternate;
}
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'fil-bus-tel_' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntStatus: {
        required: true
      },
      cpntField: {
        required: true,
        type: Object
      },
      cpntTitulo: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntOnRealizaBusca: {
        required: true
      }
    },
    components: {
      'RF-Filtro-Busca-Telas-Campos': () => import('@/components/rf-geral/busca/RF-Filtro-Busca-Telas-Campos.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        filtroBT: null,
        buttonsRod: null,
        chaveBusca: null,
        filtrado: false
      }
    },
    mounted: function () {
      this.filtroBuscaTelaIniciar()
    },
    methods: {
      filtroBuscaTelaIniciar: function () {
        // SETA O STATUS DA TELA
        this.filtroBuscaTelaSetaStatusGeral('carregando')

        // INICIA A VARIAVEL QUE VAI RECEBER OS PARAMETROS 
        this.chaveBusca = null

        // TRATA OS CAMPOS SOLICITADOS
        for (var indexF in this.cpntField) {
          // SETA O ID DO CAMPO
          this.cpntField[indexF].id = this.cpntHashId + '--' + indexF

          // VERIFICA SE TEM O CAMPO STATUS
          if ([ null, undefined ].indexOf(this.cpntField[indexF].status) !== -1) {
            this.cpntField[indexF].status = ''
          }

          // INICIA A VARIAVEL DE VALOR
          if ([ null, undefined ].indexOf(this.cpntField[indexF].value) !== -1) {
            this.cpntField[indexF].value = ''
          }
          if ([ null, undefined ].indexOf(this.cpntField[indexF].value) === -1 && [ null, undefined ].indexOf(this.cpntField[indexF].valueIni) !== -1) {
            this.cpntField[indexF].valueIni = this.cpntField[indexF].value
          }

          // SETA OS VALORES PARA O CAMPO DATA
          if (this.cpntField[indexF].tipo === 'data') {
            this.cpntField[indexF].dataIni = ''
            this.cpntField[indexF].dataFim = ''
          }

          // SETA A FUNÇÃO ONCHANGE DO CAMPO
          this.cpntField[indexF].onChange = this.filtroBuscaTelaOnChangeValue
          
          // VERIFICA SE É DO TIPO DATA O FILTRO
          if (this.cpntField[indexF].tipo === 'input-busca') {
            this.chaveBusca = indexF
          }
        }

        // SETA O BOTÃO PARA FILTRO
        this.filtroBT = {
          status: '',
          id: this.cpntHashId + '--filtroBT',
          tipo: 'icone',
          icone: { tipo: 'filtro' },
          class: [ 'btn', 'btn-default' ],
          dialog: false,
          tamanho: (document.documentElement.clientWidth >= 420 ? '400px' : '95%'),
          onClick: () => {
            // SETA SE DEVE ABRIR OU NÃO A JANELA DE FILTROS
            this.filtroBT.dialog = !this.filtroBT.dialog

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }

        // SETA OS BOTÕES DA TELA
        this.$store.state.FUN_CREATE_BUTTON_FORM(this.cpntHashId, [ 0 ], null, {
          limpar: this.filtroBuscaTelaLimparFiltros,
          env: this.filtroBuscaTelaAplicar,
        }, (buttons) => {
          buttons.env.texto = 'Aplicar filtros'
          buttons.limpar.texto = 'Limpar filtros'

          // CRIA OS BUTTONS DO FORMULARIO
          this.buttonsRod = buttons

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // SETA O STATUS DA TELA
          this.appCapturarFiltrosSelecionados(() => { this.filtroBuscaTelaSetaStatusGeral('') })
        })
      },
      filtroBuscaTelaSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      filtroBuscaTelaAplicar: function () {
        // CHAMA A FUNÃO PARA ATUALIZAR A TELA DE TRAS
        this.cpntOnRealizaBusca()

        // EXECUTA A FUNÇÃO PARA FEHAR OS FILTROS
        if (this.filtroBT.dialog === true) {
          this.filtroBT.onClick()
        }
      },
      appCapturarFiltrosSelecionados: function (callback = null) {
        // SETA O FLAG HOUVE ALTERAÇÃO NOS FILTROS
        this.filtrado = false

        // SETA OS FILTROS SELECIONADOS
        var filtros = {}

        // ADICIONA OS CAMPOS SOLICITADOS
        for (var indexF in this.cpntField) {
          switch (this.cpntField[indexF].tipo) {
            case 'data':
              // SETA O VALOR DOS CAMPOS
              filtros[indexF] = {
                ini: this.cpntField[indexF].dataIni,
                fim: this.cpntField[indexF].dataFim,
                seletor: this.cpntField[indexF].value
              }

              // VERIFICA SE TEM ALGUMA BUSCA PARA OS FILTROS
              this.filtrado = this.filtrado === true || ([ '', null, undefined ].indexOf(this.cpntField[indexF].dataIni) === -1 || [ '', null, undefined ].indexOf(this.cpntField[indexF].dataFim) === -1 || [ '', null, undefined ].indexOf(this.cpntField[indexF].value) === -1)
              break

            case 'input-busca':
              filtros[indexF] = this.cpntField[indexF].value
              break

            case 'select2-chosen':
              // SETA O VALOR DOS CAMPOS
              filtros[indexF] = this.cpntField[indexF].value

              // VERIFICA SE TEM ALGUMA BUSCA PARA OS FILTROS
              this.filtrado = this.filtrado === true || JSON.stringify(this.cpntField[indexF].value) !== JSON.stringify(this.cpntField[indexF].valueIni)
              break

            default:
              // SETA O VALOR DOS CAMPOS
              filtros[indexF] = this.cpntField[indexF].value

              // VERIFICA SE TEM ALGUMA BUSCA PARA OS FILTROS
              this.filtrado = this.filtrado === true || this.cpntField[indexF].value !== this.cpntField[indexF].valueIni
              break
          }
        }

        // VERIFICA SE FOI SELECIONADO ALGUM FILTRO
        if ([ '', null, undefined ].indexOf(filtros) === -1 && Object.keys(filtros).length === 0) {
          filtros = ''
        }

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null && typeof callback === 'function') {
          callback(filtros)
        }
      },
      filtroBuscaTelaLimparFiltros: function () {
        // ADICIONA OS CAMPOS SOLICITADOS
        for (var indexF in this.cpntField) {
          // REINICIA OS VALORES DOS CAMPOS
          switch (this.cpntField[indexF].tipo) {
            case 'data':
              this.cpntField[indexF].value = ''
              this.cpntField[indexF].dataIni = ''
              this.cpntField[indexF].dataFim = ''
              break

            case 'input-busca':
              break

            default:
              this.cpntField[indexF].value = this.cpntField[indexF].valueIni
              break
          }

          // REMOVE A MENSAGEM DE ERRO
          this.cpntField[indexF].mensagem = ''
          this.cpntField[indexF].mensagemTipo = ''

          // VERIFICA SE TEM FUNÇÃO PARA ATUALIZAR OUTRO CAMPO
          if ([ '', null, undefined ].indexOf(this.cpntField[indexF].onChangeFiltro) === -1 && typeof this.cpntField[indexF].onChangeFiltro === 'function') {
            this.cpntField[indexF].onChangeFiltro(this.cpntField[indexF].value)
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O FLAG HOUVE ALTERAÇÃO NOS FILTROS
        this.filtrado = false

        // CHAMA A FUNÇÃO PARA APLICAR A LIMPEZA DOS FILTROS
        this.filtroBuscaTelaAplicar()
      },
      filtroBuscaTelaOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // VERIFICA O TIPO DE CAMPO QUE DEVE ATUALIZAR
        switch (this.cpntField[index].tipo) {
          case 'data':
            // SETA A DATA INICIAL RECEBIDA
            this.cpntField[index].dataIni = value.ini

            // SETA A DATA FINAL RECEBIDA
            this.cpntField[index].dataFim = value.fim

            // SETA A DATA FINAL RECEBIDA
            this.cpntField[index].value = value.seletor
            break

          default:
            this.cpntField[index].value = value
            break
        }

        // REMOVE A MENSAGEM DE ERRO
        this.cpntField[index].mensagem = ''
        this.cpntField[index].mensagemTipo = ''

        // VERIFICA SE TEM FUNÇÃO PARA ATUALIZAR OUTRO CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntField[index].onChangeFiltro) === -1 && typeof this.cpntField[index].onChangeFiltro === 'function') {
          this.cpntField[index].onChangeFiltro(value)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    watch: {
      filtrado: function () {
        this.$emit('onChangeFiltrado', this.filtrado)
      }
    }
  }
</script>
